import { Container, useStyles } from '@archipro-design/aria';
import PageLayout from '@modules/articles/component/page-layout/PageLayout';
import RecentlyViewed from '@modules/articles/component/recently-viewed/RecentlyViewed';

import { Outlet } from '@remix-run/react';
import { ClientOnly } from 'remix-utils';
import { useUser } from '@modules/user';
import { json } from '@remix-run/node';
import { type LoaderFunctionArgs } from '@remix-run/node';
import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    getArchizeenCommon,
    getArticleNavigationItems,
} from '~/modules/articles/api/get-archizeen-common.server';
import { getPageLocalisation } from '~/modules/seo/api/get-page-localisation.server';
import type { APHandle } from '@modules/root/type/handle';

export const links = () => [
    {
        rel: 'stylesheet',
        href: '/assets/website/styles/swiper@9.1.0/modules/effect-fade.min.css',
    },
];

export const loader = async (args: LoaderFunctionArgs) => {
    const { context, request } = args;
    const [navItems, common, localisation] = await Promise.all([
        getArticleNavigationItems(context),
        getArchizeenCommon({
            request: request,
            ...context,
        }),
        getPageLocalisation(args),
    ]);

    if (!navItems) {
        return new Response('Not Found', {
            status: 404,
        });
    }

    return json({
        navItems,
        common,
        localisation,
    });
};

export const handle: APHandle = {
    hideContactArchiPro: false,
};

const ArticleFooterContainer: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(64),
    [theme.screen.laptop]: {
        marginBottom: pxToRem(224),
    },
});

const ArchizeenRootPage = () => {
    const user = useUser();
    const isLoggedIn = user.__typename === 'Me';
    const { css } = useStyles();

    return (
        <PageLayout>
            <Container>
                <>
                    <Outlet />
                    {isLoggedIn && (
                        <ClientOnly fallback={<></>}>
                            {() => (
                                <div className={css(ArticleFooterContainer)}>
                                    <RecentlyViewed />
                                </div>
                            )}
                        </ClientOnly>
                    )}
                </>
            </Container>
        </PageLayout>
    );
};

export default ArchizeenRootPage;
